import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { UserData } from '../../models/UserData';

export type UserState = {
  data: UserData;
};

// Slice
export const userSlice = createSlice({
  name: 'user',
  initialState: {} as UserState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<UserData>) => {
      state.data = payload;
    },
    logout: state => {
      state.data = null;
    },
  },
});

export default userSlice;

export const { setUser, logout } = userSlice.actions;
